import {Injectable, signal} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {map, Observable} from "rxjs";
import {environment} from '@env/environment';
import {SimpleMessage} from '../models/input.model';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  isOpen = signal(false);
  errorMessage = signal('');
  errorTitle = signal('Errore generico');

  showMessage(message: SimpleMessage) {
    this.errorMessage.set(message.message);
    this.errorTitle.set(message.statusText || 'Errore generico');
    this.isOpen.set(true);
  }

  closeMessage() {
    this.isOpen.set(false);
  }
}
